import "react-slideshow-image/dist/styles.css";
import "./slideShowImageStyles.scss";
import { Slide } from "react-slideshow-image";
import { useRef, useEffect } from "react";
import { IoIosArrowBack } from "react-icons/io";
import { IoIosArrowForward } from "react-icons/io";
import { buildSrcSet, variantsFor } from "../../../../utils/image";

export const SlideShowImage = ({ images, imageShowing, setOpenZoom, car }) => {
    const slideRef = useRef(null);

    // Posiciona el visor en la misma imagen que se estaba viendo en el carousel.
    useEffect(() => {
        slideRef.current.goTo(imageShowing);
    }, [imageShowing]);

    useEffect(() => {
        window.addEventListener("keydown", handleKeyDown);

        // Limpiar el evento al desmontar el componente
        return () => {
            window.removeEventListener("keydown", handleKeyDown);
        };
    }, []);

    const handleKeyDown = (event: any) => {
        switch (event.keyCode) {
            case 27:
                setOpenZoom(false);
                break;
            case 37:
                previousSlide();
                break;
            case 39:
                nextSlide();
                break;
            default:
                break;
        }
    };

    // Navegación infinita: desde la última imagen se pasa a la primera y viceversa.
    const previousSlide = () => {
        slideRef.current.goBack();
    };

    const nextSlide = () => {
        slideRef.current.goNext();
    };

    return (
        <div className="slide-container">
            <button
                onClick={previousSlide}
                className="custom-arrow-prev"
                style={{ position: "absolute", top: 0, zIndex: 1, bottom: 0, margin: "auto" }}
            >
                <IoIosArrowBack />
            </button>
            <button
                onClick={nextSlide}
                className="custom-arrow-next"
                style={{ position: "absolute", top: 0, zIndex: 1, bottom: 0, margin: "auto" }}
            >
                <IoIosArrowForward />
            </button>

            <Slide ref={slideRef} autoplay={false} arrows={false} transitionDuration={100} infinite={true}>
                {images.map((image: string, i: number) => {
                    // Visor a pantalla completa: es la superficie que mas resolucion exige,
                    // asi que pedimos el ancho del viewport y dejamos que el navegador elija
                    // la variante mas grande (incluido el original) via srcSet.
                    const srcSet = buildSrcSet(variantsFor(car?.imageSrcsetByKey, image));
                    return (
                        <div key={i}>
                            <img
                                src={image}
                                srcSet={srcSet}
                                sizes={srcSet ? "100vw" : undefined}
                                className="images_styles"
                                alt={car?.name}
                                title={car?.name}
                            />
                        </div>
                    );
                })}
            </Slide>
        </div>
    );
};
